import { apiRequest } from "../util/apiUtils";

export const siteSettingsDetals = async (payload) => {
  try {
    const res = await apiRequest("get", `site-setting/details`);

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const siteSettingsUpdate = async (payload) => {
  try {
    const res = await apiRequest(
      "put",
      `site-setting/edit`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    return err;
  }
};
